module.exports = __webpack_public_path__ + "static/media/ob-interest.467e1837.svg";